import { logomarkDefinition } from '@deepdive-icons';
import styles from './Logomark.module.css';

/**
 * The DeepDive brand mark — Figma `Logomark_Old` (2300:451), drawn at 24x24.
 *
 * Two-tone: the drop takes `currentColor`, so the caller controls it
 * (defaults to icon/primary), and the strokes and spark over it are icon/inverse.
 * So recolour it only to a colour icon/inverse still reads against: set the drop
 * to icon/inverse itself and the strokes disappear into it.
 */
export type LogomarkProps = {
  /** Accessible name. Defaults to "DeepDive"; pass an empty string if decorative. */
  label?: string;
  className?: string;
};

export function Logomark({ label = 'DeepDive', className }: LogomarkProps) {
  const decorative = label === '';

  return (
    <svg
      className={className ? `${styles.logomark} ${className}` : styles.logomark}
      viewBox={logomarkDefinition.viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : label}
      aria-hidden={decorative || undefined}
      focusable="false"
    >
      {logomarkDefinition.shape.map((d) => (
        <path key={d.slice(0, 32)} d={d} fill="currentColor" />
      ))}
      {logomarkDefinition.marks.map((d) => (
        <path key={d.slice(0, 32)} d={d} className={styles.marks} />
      ))}
    </svg>
  );
}
